import { render, staticRenderFns } from "./ContactFavoris.vue?vue&type=template&id=541eb116&"
import script from "./ContactFavoris.vue?vue&type=script&lang=js&"
export * from "./ContactFavoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports